<div class="bg-gray-50 w-full min-h-screen py-6 px-4 sm:px-6 lg:px-8">

  <!-- Filter Panel -->
  <div class="w-full bg-white rounded-lg border border-gray-200 shadow-sm p-4 mb-8 overflow-x-auto">
    <div class="flex items-start justify-between gap-6 min-w-[1000px]">

      <!-- Logo + Title -->
      <div class="flex items-center gap-4 px-2 py-1 rounded-md hover:opacity-90 transition-opacity duration-200">
        <img src="https://cdn-icons-png.flaticon.com/128/6370/6370400.png" alt="Logo" class="h-9 w-9 object-contain" />
        <h1 class="text-2xl font-medium text-[#AA7B00] tracking-wide">Retail Stock List</h1>
      </div>


      <!-- Filters Section -->
      <div class="grid justify-end">
        <div class="grid grid-flow-col auto-cols-max gap-2 items-end bg-white p-2 rounded-lg">

          <!-- Start Range -->
          <div class="relative w-32">
            <input type="text" id="start_range"
              class="block px-2 py-2 w-full text-sm text-gray-800 bg-white rounded-md border border-[#DCDCDC] appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="start_range"
              class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 bg-white px-1.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">
              Start Range</label>
          </div>

          <!-- End Range -->
          <div class="relative w-32">
            <input type="text" id="end_range"
              class="block px-2 py-2 w-full text-sm text-gray-800 bg-white rounded-md border border-[#DCDCDC] appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="end_range"
              class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 bg-white px-1.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">
              End Range</label>
          </div>
          <div class="flex items-center">
            <input type="checkbox" class="h-4 w-4 rounded border-gray-300 text-yellow-600 focus:ring-yellow-500 -mt-9" />
          </div>


          <!-- Weight Type -->
          <div class="relative w-20">
            <select
              class="block px-2 py-2 w-full text-sm text-gray-800 bg-white rounded-md border border-[#DCDCDC] focus:outline-none focus:ring-0 focus:border-c19725 peer">
              <option>WT</option>
              <option>GM</option>
              <option>MG</option>
              <option>KG</option>
            </select>
          </div>

          <!-- Material Type -->
          <div class="relative w-24">
            <select
              class="block px-2 py-2 w-full text-sm text-gray-800 bg-white rounded-md border border-[#DCDCDC] focus:outline-none focus:ring-0 focus:border-c19725 peer">
              <option>Gold</option>
              <option>Silver</option>
              <option>Crystal</option>
              <option>Imitation</option>
              <option>Sterling</option>
              <option>Other</option>
            </select>
          </div>

          <!-- Item Category -->
          <div class="relative w-36">
            <input type="text" id="item_category"
              class="block px-2 py-2 w-full text-sm text-gray-800 bg-white rounded-md border border-[#DCDCDC] appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="item_category"
              class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 bg-white px-1.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">
              Item Category</label>
          </div>

          <!-- Item Name -->
          <div class="relative w-36">
            <input type="text" id="item_name"
              class="block px-2 py-2 w-full text-sm text-gray-800 bg-white rounded-md border border-[#DCDCDC] appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="item_name"
              class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 bg-white px-1.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">
              Item Name</label>
          </div>

          <!-- GO Button -->
          <button type="submit"
            class="px-4 py-2 rounded-tl-[5px] rounded-[5px] border-[0.5px] border-[#D9D9D9] text-[#898989] text-sm sm:text-sm lg:text-base hover:bg-[#f6f1cb] hover:text-black">
            GO
          </button>

        </div>
      </div>
    </div>
  </div>


  <!-- Product Cards Grid -->
  <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5 gap-4">

    <!-- Card with Classic Hover Effect -->
    <div *ngFor="let product of products"
      class="bg-white border border-gray-200 rounded-lg shadow-sm p-4 flex flex-col transition-all duration-300 ease-in-out hover:shadow-xl hover:-translate-y-1">

      <!-- Card Content -->
      <div class="flex-grow">
        <img [src]="product.imageUrl" alt="Jewellery Image" class="w-36 h-36 object-contain mx-auto mb-4">
        <h2 class="text-lg font-medium text-center text-[#0F3583] mb-1">{{ product.name }}</h2>
        <p class="text-sm text-gray-500 text-center mb-5">{{ product.details }}</p>


        <!-- Product Details -->
        <div class="flex justify-center items-center text-sm text-center gap-3">
            <div class="flex flex-col items-center text-gray-400 font-medium w-20">
                <span>GROSS WT</span>
                <span class="text-gray-800 font-medium mt-1">{{ product.grossWeight }}</span>
            </div>
            <div class="h-8 border-l border-gray-200"></div>
            <div class="flex flex-col items-center text-gray-400 font-medium w-20">
                <span>NET WT</span>
                <span class="text-gray-800 font-medium mt-1">{{ product.netWeight }}</span>
            </div>
            <div class="h-8 border-l border-gray-200"></div>
            <div class="flex flex-col items-center text-gray-400 font-medium w-20">
                <span>QTY</span>
                <span class="text-gray-800 font-medium mt-1">{{ product.quantity }}</span>
            </div>
        </div>
      </div>

      <!-- Card Footer -->
      <div class="flex items-center justify-between mt-6 pt-4 border-t border-gray-100">
        <p class="text-xl font-bold text-[#D26216]">{{ product.price }}</p>

        <button class="group flex items-center rounded-md border border-[#305CDE] text-[#305CDE] font-medium text-sm hover:bg-[#305CDE] hover:text-white transition-colors duration-300">
          <span class="px-4 py-2">
            More Details
          </span>
          <span class="px-2 py-2 border-l border-[#305CDE] group-hover:border-white">
             <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
            </svg>
          </span>
        </button>
      </div>

    </div>

  </div>
</div>
